<div class="page-layout carded fullwidth left-sidebar">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button class="mr-16" [routerLink]="'/profile-creator'">
              <mat-icon>arrow_back</mat-icon>
          </button>
            <h2 class="m-0">{{'PERFILES.USUARIO.TITUHEAD' | translate}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <span>{{'PERFILES.USUARIO.INFO' | translate}}</span>
            </div>
            <!-- / CONTENT TOOLBAR -->
            <mat-tab-group mat-align-tabs="start">
                ///****Tab para crea Usuarios Nuevos**********///
                <mat-tab label="{{'PERFILES.USUARIO.TITUCREARHEAD' | translate}}">
                    <!-- CONTENT -->
                    <div class="content p-24" fusePerfectScrollbar>

                        <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                            <!-- REACTIVE FORM EXAMPLE -->

                            <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" [formGroup]="formUserRegister">

                                <!-- <div class="h2 mb-24">USER REGISTER</div> -->

                                <div fxLayout="row" fxLayoutAlign="start start" fxFlex="1 0 auto">

                                    <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                                        <mat-label>{{'PERFILES.USUARIO.USUARIO' | translate}}</mat-label>
                                        <input matInput formControlName="emailRegister" #idUser autocomplete="off">
                                        <mat-icon matSuffix class="secondary-text">email</mat-icon>
                                        <mat-error>{{'PERFILES.USUARIO.USUARIOREQUIRED' | translate}}</mat-error>
                                    </mat-form-field>
                                    <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="50">
                                      <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                                        <mat-label>{{'PERFILES.USUARIO.CONTRA' | translate}}</mat-label>
                                        <input matInput [type]="hide ? 'password' : 'text'" formControlName="passwordUser" #idPassword autocomplete="off" (keyup)="validarPassRegis($event)">
                                        <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                          <mat-icon>{{hide ? 'lock' : 'lock_open'}}</mat-icon>
                                        </button>
                                        <mat-error>{{'PERFILES.USUARIO.CONTRAREQUIRED' | translate}}</mat-error>
                                      </mat-form-field>
                                      <!-- <p><em>{{'PERFILES.USUARIO.PASSWORDSAFE' | translate}}</em></p> -->
                                    <mat-progress-bar mode="determinate" value="{{medirPassRegis}}" class="valorRegis"></mat-progress-bar>
                                    </div>

                                    <div class="modalReglas" fxFlex="20">
                                  <div *ngFor="let reglas of regalasPassRegis" fxLayout="row" fxLayoutAlign="start center" style="margin-top:0px;">
                                    {{'PERFILES.USUARIO.'+reglas.regla | translate}}
                                    <mat-icon *ngIf="!reglas.estatus" class="iconletrasReglasFalse">highlight_off</mat-icon>
                                    <mat-icon *ngIf="reglas.estatus" class="iconletrasReglasTrue">check_circle_outline</mat-icon>
                                  </div>
                                  </div>

                                </div>
                                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                    <mat-form-field appearance="outline" fxFlex="100">
                                        <mat-label>{{'PERFILES.USUARIO.NIVEL' | translate}}</mat-label>
                                        <mat-select required formControlName="selectLevel" #selectNivel>
                                            <mat-option *ngFor="let level of levels" [value]="level.nivel">
                                                <!-- {{level.nombreNivel}} -->
                                                {{'PERFILES.USUARIO.NIVELES.'+level.nivel | translate}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                                        <mat-error>{{'PERFILES.USUARIO.LEVELREQUIRED' | translate}}</mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="selectNivel.value == 19" style="margin-bottom:16px">
                                  <mat-radio-group aria-label="Select an option" formControlName="versDefaultLevelResultV2">
                                  <mat-radio-button value="1" style="margin-left:16px" (change)="cambiarVersion($event.value)">{{'CONSULTATABLA.TEX_VERS_RESULT_OPC1' | translate}}</mat-radio-button>
                                  <mat-radio-button value="2" style="margin-left:16px" (change)="cambiarVersion($event.value)">{{'CONSULTATABLA.TEX_VERS_RESULT_OPC2' | translate}}</mat-radio-button>
                                  </mat-radio-group>
                                   <mat-form-field appearance="outline" fxFlex="30" style="margin-left:16px" *ngIf="!versDisabledTextLevelResultV2">
                                      <mat-label>{{'CONSULTATABLA.TEX_VERS_RESULT_LAB' | translate}}</mat-label>
                                      <input matInput formControlName="versLevelResultV2" [(ngModel)]='versTextLevelResultV2' placeholder="{{'CONSULTATABLA.TEX_PLAC_RESULT_LAB' | translate}}">
                                      <mat-icon matSuffix class="disabled-text">edit</mat-icon>
                                  </mat-form-field>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="selectNivel.value == 1 || selectNivel.value == 5 || selectNivel.value == 8 || selectNivel.value == 4 || selectNivel.value == 10 || selectNivel.value == 12 || selectNivel.value == 13 || selectNivel.value == 14 || selectNivel.value == 18 || selectNivel.value == 19">
                                    <mat-form-field appearance="outline" fxFlex>
                                        <mat-label>{{'CONSULTATABLA.BUSCAR' | translate}}</mat-label>
                                        <input formControlName="search" matInput [(ngModel)]='busqueda' (keyup)="getListaEmpresas(1,1)" placeholder="{{'CONSULTATABLA.BUSCAR_PLACEH' | translate}}">
                                        <mat-icon matSuffix class="disabled-text">search</mat-icon>
                                    </mat-form-field>


                                    <mat-form-field appearance="outline" fxFlex="100">
                                        <mat-label>{{'PERFILES.USUARIO.COMPANY' | translate}}</mat-label>
                                        <mat-select required [(value)]="selectedEnterprise" formControlName="selectEnterprise">
                                            <!-- <mat-option *ngFor="let enterprise of enterprises" [value]="enterprise._id">
                                        {{enterprise.datosEmpresa.nombreEmpresa}}
                                    </mat-option> -->
                                            <mat-option *ngFor="let enterprise of enterprises | filter:busqueda" [value]="enterprise._id">
                                                <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                                                    <!-- {{enterprise.datosEmpresa.nombreEmpresa}}-->
                                                    <h6>{{enterprise.datosEmpresa.nombreEmpresa}}</h6>
                                                    <h3>({{'PERFILES.EMPRESA.SECCIONES.SEC1.CATALOGOS.INSTITUTOS.'+enterprise.datosEmpresa.institutoEmpresa | translate}})</h3>
                                                </div>
                                            </mat-option>
                                        </mat-select>
                                        <mat-icon matSuffix class="secondary-text">business</mat-icon>
                                        <mat-error>{{'PERFILES.USUARIO.COMPANY_REQUIRED' | translate}}</mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="selectNivel.value == 2 || selectNivel.value == 11">

                                    <mat-form-field appearance="outline" fxFlex="100">
                                        <mat-label>{{'PERFILES.EMPRESA.SECCIONES.SEC1.INSTITUTO' | translate}}</mat-label>
                                        <mat-select required [(value)]="instituto" formControlName="instituto">
                                            <mat-option *ngFor="let institute of institutes" [value]="institute.numInstituto">
                                                <!-- {{institute.regionInstituto}} -->
                                                {{'PERFILES.EMPRESA.SECCIONES.SEC1.CATALOGOS.INSTITUTOS.'+institute.numInstituto | translate}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                                        <mat-error>{{'PERFILES.EMPRESA.SECCIONES.SEC1.INSTITUTO_REQUIRED' | translate}}</mat-error>
                                    </mat-form-field>

                                </div>
                                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="selectNivel.value == 17">

                                  <mat-form-field appearance="outline" fxFlex="70" class="pr-4">
                                      <mat-label>{{'PERFILES.USUARIO.USE_NAM' | translate}}</mat-label>
                                      <input matInput formControlName="userName" #idUser autocomplete="off">
                                      <mat-icon matSuffix class="secondary-text">empersonail</mat-icon>
                                      <mat-error>{{'PERFILES.USUARIO.USUARIONAMEREQUIRED' | translate}}</mat-error>
                                  </mat-form-field>

                                    <!-- <mat-form-field appearance="outline" fxFlex="30" >
                                        <mat-label>{{'PERFILES.EMPRESA.SECCIONES.SEC1.INSTITUTO' | translate}}</mat-label>
                                        <mat-select required [(value)]="instituto" formControlName="instituto">
                                            <mat-option *ngFor="let institute of institutes" [value]="institute.numInstituto">
                                                {{'PERFILES.EMPRESA.SECCIONES.SEC1.CATALOGOS.INSTITUTOS.'+institute.numInstituto | translate}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                                        <mat-error>{{'PERFILES.EMPRESA.SECCIONES.SEC1.INSTITUTO_REQUIRED' | translate}}</mat-error>
                                    </mat-form-field> -->



                                </div>
                                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="selectNivel.value == 9">
                                    <mat-form-field appearance="outline" fxFlex>
                                        <mat-label>{{'CONSULTATABLA.BUSCAR' | translate}}</mat-label>
                                        <input formControlName="search" matInput [(ngModel)]='busqueda' (keyup)="getListaEmpresas(1,1)" placeholder="{{'CONSULTATABLA.BUSCAR_PLACEH' | translate}}">
                                        <mat-icon matSuffix class="disabled-text">search</mat-icon>
                                    </mat-form-field>


                                    <mat-form-field appearance="outline" fxFlex="80">
                                        <mat-label>{{'PERFILES.USUARIO.COMPANY' | translate}}</mat-label>
                                        <mat-select required [(value)]="selectedEnterprise" formControlName="selectEnterprise">
                                            <mat-option *ngFor="let enterprise of enterprises | filter:busqueda" [value]="enterprise._id" (clic)="habilitarVersion()">
                                                {{enterprise.datosEmpresa.nombreEmpresa}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-icon matSuffix class="secondary-text">business</mat-icon>
                                        <mat-error>{{'PERFILES.USUARIO.COMPANY_REQUIRED' | translate}}</mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex="100">
                                        <mat-label>Versión para resultados</mat-label>
                                        <mat-select required [(value)]="instituto" formControlName="instituto">
                                            <mat-option *ngFor="let ver of selectVersion" [value]="ver.id">
                                                <!-- {{institute.regionInstituto}} -->
                                                {{ ver.nombre }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                                        <mat-error>{{'PERFILES.EMPRESA.SECCIONES.SEC1.INSTITUTO_REQUIRED' | translate}}</mat-error>
                                    </mat-form-field>
                                </div>

                                <button mat-raised-button color="accent" (click)="registerUser()">
                        {{'PERFILES.USUARIO.GUARDA' | translate}}
                      </button>
                            </form>
                        </div>

                    </div>
                    <!-- / CONTENT -->
                </mat-tab>



                ///****Tab para Buscar Usuarios por Empresa **********///
                <mat-tab label="{{'PERFILES.USUARIO.TITUBUSCARHEAD' | translate}}">
                    <mat-form-field class="filtro" appearance="outline">
                        <mat-label>{{'PERFILES.USUARIO.TITUBUSCAREMPRESA' | translate}}</mat-label>
                        <input matInput [(ngModel)]="busquedaUsuario" (keyup)="getListaEmpresas(1,2)" placeholder="{{'CONSULTATABLA.BUSCAR_PLACEH' | translate}}">
                        <mat-icon matSuffix class="secondary-text">search</mat-icon>
                    </mat-form-field>

                    <mat-form-field class="filtroSelect" appearance="outline">
                        <mat-label>{{'PERFILES.USUARIO.COMPANY' | translate}}</mat-label>
                        <mat-select required [(value)]="selectedEnterpriseBusU" fxLayoutAlign="space-between center">
                            <mat-option *ngFor="let enterprise of enterprises | filter:busquedaUsuario" [value]="enterprise._id" (click)="getUsuariosEmpresas(selectedEnterpriseBusU,enterprise.datosEmpresa.nombreEmpresa,enterprise.datosEmpresa.institutoEmpresa)">
                                <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                                    <h6>{{enterprise.datosEmpresa.nombreEmpresa}}</h6>
                                    <h3>({{'PERFILES.EMPRESA.SECCIONES.SEC1.CATALOGOS.INSTITUTOS.'+enterprise.datosEmpresa.institutoEmpresa | translate}})</h3>
                                </div>
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix class="secondary-text">business</mat-icon>

                        <mat-error>{{'PERFILES.USUARIO.COMPANY_REQUIRED' | translate}}</mat-error>
                    </mat-form-field>
                    <ng-container *ngIf="cargando">
                        <div fxLayout="column" fxLayoutAlign="space-between center">
                            <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                            <h1>{{'CONSULTARENCUESTA.CARGANDO' | translate}}</h1>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!cargando">
                        <ng-container *ngIf="!usuariosEncontrados">
                            <div class="statusDiv" fxLayout="column" fxLayoutAlign="center center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                                <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                                    <h2>{{'CONSULTATABLA.TEX-MENS-1' | translate}} {{nombreEmpresaBuscar}} {{'CONSULTATABLA.TEX-MENS-2' | translate}}</h2>
                                    <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="usuariosEncontrados">
                          <div class="" fxLayout="column" *ngIf="dataSource!=undefined">
                            <div fxFlex="50" style="width:50%" >
                              <mat-form-field class="filtro" appearance="outline" fxFlex>
                                <mat-label>{{'PERFILES.USUARIO.TITUBUSCARHEAD' | translate}}</mat-label>
                                <input matInput [(ngModel)]='searchUserCompany' (keyup)="applyFilterUserCompany($event.target.value)" placeholder="{{'PERFILES.USUARIO.TITUBUSCARHEAD' | translate}}">
                              </mat-form-field>

                            </div>
                            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="width:100%">

                              <ng-container matColumnDef="nomemp">
                                <th mat-header-cell *matHeaderCellDef>{{'PERFILES.USUARIO.TH-NOMEMPRE' | translate}}</th>
                                <td mat-cell *matCellDef="let element">{{element.convertedId.datosEmpresa.nombreEmpresa}}</td>
                              </ng-container>


                              <ng-container matColumnDef="correo">
                                <th mat-header-cell *matHeaderCellDef> {{'PERFILES.USUARIO.TH-USUARIO' | translate}}</th>
                                <td mat-cell *matCellDef="let element"> {{element.user}} </td>
                              </ng-container>

                              <ng-container matColumnDef="tipousu">
                                <th mat-header-cell *matHeaderCellDef> {{'PERFILES.USUARIO.TH-TUSUARIO' | translate}}</th>
                                <!-- <ng-container *ngFor="let tipo of arregloTipoUsuario"  > -->
                                  <td mat-cell *matCellDef="let element"> {{'PERFILES.USUARIO.NIVELES.'+element.level | translate}}</td>
                                </ng-container>
                                <!-- </ng-container> -->

                                <ng-container matColumnDef="accion">
                                  <th mat-header-cell *matHeaderCellDef> {{'PERFILES.USUARIO.TH-ACCIONES' | translate}} </th>
                                  <td mat-cell *matCellDef="let element">
                                    <ng-container>
                                      <button mat-mini-fab class="mr-20" color="warn" matTooltip="{{'PERFILES.USUARIO.ACC-DELET' | translate}}" (click)="deleteUsuarios(element._id,element.user,'empresa')">
                                        <mat-icon>delete_forever</mat-icon>
                                      </button>
                                      <button mat-mini-fab class="mr-20" matTooltip="{{'PERFILES.USUARIO.ACC-EDIT' | translate}}" color="warn" (click)="openEditarUsuarioEmpresa(element._id,element.user,element.level,element.institutoId,element.convertedId.datosEmpresa.nombreEmpresa)">
                                        <mat-icon>edit</mat-icon>
                                      </button>

                                    </ng-container>

                                  </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                              </table>
                              <mat-paginator *ngIf="dataSource!=undefined" class="tamaño" style-paginator  showFirstLastButtons [showTotalPages]="3" [pageSizeOptions]="[15, 50, 100, 500]" [length]="dataSource.data.length"></mat-paginator>

                          </div>

                        </ng-container>





                    </ng-container>
                </mat-tab>
                ///****Tab para Buscar Usuarios por GPTW O ITBM **********///
                <mat-tab label="{{'PERFILES.USUARIO.TITUUSERGPTWHEAD' | translate}}">
                    <div class="" fxLayout="row" fxLayoutAlign="space-between stretch">
                        <div fxFlex="50">
                            <mat-form-field class="filtro" appearance="outline" fxFlex>
                                <!-- <mat-label>{{'CONSULTATABLA.BUSCAR' | translate}}</mat-label> -->
                                <mat-label>{{'PERFILES.USUARIO.TITUBUSCARHEAD' | translate}}</mat-label>
                                <input matInput [(ngModel)]='respuestagptw' (keyup)="getUsuariosEmpresasGptw(1)" placeholder="{{'PERFILES.USUARIO.TITUBUSCARHEAD' | translate}}">
                            </mat-form-field>

                        </div>
                        <div fxFlex="50" fxLayout="row" fxLayoutAlign="end center">
                            <h3><b>{{contadorInicioEmpresaGPTW}} - {{contadorFinEmpresaGPTW}}</b> {{'CONSULTATABLA.PAGINATOR_1' | translate}} <b>{{totalEmpresasEmpresaGPTW}}</b> {{'PERFILES.USUARIO.USUARIO-T' | translate}}</h3>
                            <button mat-icon-button (click)="getUsuariosEmpresasGptw(prevPagEmpresaGPTW)">
                  <mat-icon>keyboard_arrow_left</mat-icon>
                </button>
                            <button mat-icon-button (click)="getUsuariosEmpresasGptw(nextPagEmpresaGPTW)">
                  <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
                        </div>

                    </div>
                    <!-- ///****Table de usuarios GPTW****/// -->
                    <ng-container *ngIf="nivelUsuario==2">
                        <table mat-table [dataSource]="dataSourceEmpresaGPTW" class="mat-elevation-z8" style="width:100%">


                            <ng-container matColumnDef="correo">
                                <th mat-header-cell *matHeaderCellDef> {{'PERFILES.USUARIO.TH-USUARIO' | translate}}</th>
                                <td mat-cell *matCellDef="let element"> {{element.user}} </td>
                            </ng-container>




                            <ng-container matColumnDef="accion">
                                <th mat-header-cell *matHeaderCellDef> {{'PERFILES.USUARIO.TH-ACCIONES' | translate}} </th>
                                <td mat-cell *matCellDef="let element">
                                    <ng-container>
                                        <button mat-mini-fab class="mr-20" color="warn" matTooltip="{{'PERFILES.USUARIO.ACC-DELET' | translate}}" (click)="deleteUsuarios(element._id,element.user,'admin')">
                                    <mat-icon>delete_forever</mat-icon>
                                      </button>
                                        <ng-container>
                                            <button mat-mini-fab class="mr-20" matTooltip="{{'PERFILES.USUARIO.ACC-EDIT' | translate}}" color="warn" (click)="openEditarUsuarioEmpresa(element._id,element.user,element.level,element.institutoId)">
                                          <mat-icon>edit</mat-icon>
                                        </button>
                                        </ng-container>

                                    </ng-container>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsGptwEmpresas"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsGptwEmpresas;"></tr>
                        </table>
                    </ng-container>
                    <!-- ///****Table de usuarios ITBM****/// -->
                    <ng-container *ngIf="nivelUsuario==3">
                        <table mat-table [dataSource]="dataSourceEmpresaGPTW" class="mat-elevation-z8" style="width:100%">
                            <ng-container matColumnDef="correo">
                                <th mat-header-cell *matHeaderCellDef> {{'PERFILES.USUARIO.TH-USUARIO' | translate}}</th>
                                <td mat-cell *matCellDef="let element"> {{element.user}} </td>
                            </ng-container>
                            <ng-container matColumnDef="instituto">
                                <th mat-header-cell *matHeaderCellDef> {{'PERFILES.USUARIO.TH-INSTITUTO' | translate}}</th>
                                <td mat-cell *matCellDef="let element"> {{'PERFILES.EMPRESA.SECCIONES.SEC1.CATALOGOS.INSTITUTOS.'+element.institutoId | translate}}</td>
                            </ng-container>
                            <ng-container matColumnDef="tipousu">
                                <th mat-header-cell *matHeaderCellDef> {{'PERFILES.USUARIO.TH-TUSUARIO' | translate}}</th>
                                <!-- <ng-container *ngFor="let tipo of arregloTipoUsuario"  > -->
                                <td mat-cell *matCellDef="let element"> {{'PERFILES.USUARIO.NIVELES.'+element.level | translate}}</td>
                            </ng-container>
                            <ng-container matColumnDef="accion">
                                <th mat-header-cell *matHeaderCellDef> {{'PERFILES.USUARIO.TH-ACCIONES' | translate}} </th>
                                <td mat-cell *matCellDef="let element">
                                    <ng-container>
                                        <button mat-mini-fab class="mr-20" color="warn" matTooltip="{{'PERFILES.USUARIO.ACC-DELET' | translate}}" (click)="deleteUsuarios(element._id,element.user,'admin')">
                        <mat-icon>delete_forever</mat-icon>
                      </button>
                                        <ng-container>
                                            <button mat-mini-fab class="mr-20" matTooltip="{{'PERFILES.USUARIO.ACC-EDIT' | translate}}" color="warn" (click)="openEditarUsuarioEmpresa(element._id,element.user,element.level,element.institutoId)">
                          <mat-icon>edit</mat-icon>
                        </button>
                                        </ng-container>

                                    </ng-container>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsGptwyItbmEmpresas"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsGptwyItbmEmpresas;"></tr>
                        </table>
                    </ng-container>

                </mat-tab>

            </mat-tab-group>
        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
